// Right rail "Order Info" tab body (docs/06-ux-rules.md "Right rail" /
// "Order Info panel"; veda:projects/unified-feedback-inbox/parts/
// p08-right-rail.md D3; VISUAL-SPEC.md §4 "Order Info tab"). Shown for 👍
// rows too — no rating gate.
//
// The item list + totals breakdown is `components/OrderSnapshotReceipt`, the
// same component `components/ReceiptModal.tsx` renders (minus its modal
// chrome and "Your items" header) — not
// `scenes/Users/View/Activity/OrderReceipt` (`Table`/`Row`), which renders a
// DIFFERENT type shape (`PosOrder`/`OrderLineItem`: string quantities, a
// nested modifier TREE, POS-specific metadata rows) that doesn't fit
// `OrderSnapshot`'s flatter shape (numeric quantity, no modifier nesting).
// This panel adds the rail-only Date/Location section above (a single
// `KeyValueList`) — the real v70 render has no separate delivery-method/
// Channel row at all (2026-09-20 spec correction), just these two fields.
import { Text } from '@thanx/uikit/text'
import type { OrderSnapshot } from 'api/recoveryAi.types'
import KeyValueList, { KeyValueListItem } from 'components/KeyValueList'
import OrderSnapshotReceipt from 'components/OrderSnapshotReceipt'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { formatNumericDateTime } from 'utilities/dateFormatters'
import RailSectionHeading from './RailSectionHeading'

const t = buildTranslate('feedback_inbox.rail.order_info')
// The field list's accessible name reuses the tab title.
const tRail = buildTranslate('feedback_inbox.rail')

const RECEIPT_PADDING = '8px 0 16px'

export interface OrderInfoPanelProps {
  order: OrderSnapshot | null
}

const OrderInfoPanel = ({ order }: OrderInfoPanelProps) => {
  const [css] = useStyletron()

  if (!order) {
    return (
      <Text.BodyText4 tag="p" color="grey70">
        {t('unavailable')}
      </Text.BodyText4>
    )
  }

  const items: KeyValueListItem[] = [
    {
      label: t('date_time'),
      value: formatNumericDateTime(order.orderDate) || t('line_unavailable'),
    },
    {
      label: t('ordering_location'),
      value: order.locationName ?? t('line_unavailable'),
    },
  ]

  return (
    <div>
      {/* Same heading as CustomerPanel's "Customer" title. The rows draw
          their own rules, so the section has no bottom border. */}
      <RailSectionHeading title={t('title')} />
      <KeyValueList items={items} ariaLabel={tRail('tabs.order_info')} />

      {/* Prototype `.fb-rcpt` sits 8px under the last row. */}
      <div className={css({ padding: RECEIPT_PADDING })}>
        <OrderSnapshotReceipt
          order={order}
          itemsGap="12px"
          itemsMarginTop="0"
        />
      </div>
    </div>
  )
}

export default OrderInfoPanel
